const routerInstance = [
    /* -------------------------------- DASHBOARD ------------------------------- */
    {
        path: 'dashboard',
        name: 'instanceDashboard',
        component: () => import('../views/instance/dashboard/index.vue'),
        meta: {
            pagePermission: 'dashboard.index'
        }
    },
    /* -------------------------------- END DASHBOARD ------------------------------- */

    /* -------------------------------- FORM ENGINE ------------------------------- */
    {
        path: 'form-engine',
        name: 'instanceFormEngine',
        component: () => import('../views/instance/formEngine/index.vue'),
        meta: {
            pagePermission: 'form-template.index'
        }
    },
    {
        path: 'form-engine/create',
        name: 'instanceFormEngineCreate',
        component: () => import('../views/instance/formEngine/form.vue'),
        meta: {
            pagePermission: 'form-template.store'
        }
    },
    {
        path: 'form-engine/:id/edit',
        name: 'instanceFormEngineEdit',
        component: () => import('../views/instance/formEngine/form.vue'),
        meta: {
            pagePermission: 'form-template.update'
        }
    },
    /* -------------------------------- END FORM ENGINE ------------------------------- */

    /* -------------------------------- SERVICE ------------------------------- */
    {
        path: 'object-retribution',
        name: 'instanceServices',
        component: () => import('../views/instance/services/index.vue'),
        meta: {
            pagePermission: 'service.index'
        }
    },
    {
        path: 'object-retribution/create',
        name: 'instanceServicesCreate',
        component: () => import('../views/instance/services/form.vue'),
        meta: {
            pagePermission: 'service.store'
        }
    },
    {
        path: 'object-retribution/:id/edit',
        name: 'instanceServicesEdit',
        component: () => import('../views/instance/services/form.vue'),
        meta: {
            pagePermission: 'service.update'
        }
    },
    /* -------------------------------- END SERVICE ------------------------------- */

    /* -------------------------------- TRANSACTION ------------------------------- */
    {
        path: 'transaction',
        name: 'instanceTransaction',
        component: () => import('../views/instance/transaction/index.vue'),
        meta: {
            pagePermission: 'transaction.index'
        }
    },
    {
        path: 'transaction/create',
        name: 'instanceTransactionCreate',
        component: () => import('../views/instance/transaction/form.vue'),
        meta: {
            pagePermission: 'transaction.store'
        }
    },
    {
        path: 'transaction/edit/:id',
        name: 'instanceTransactionEdit',
        component: () => import('../views/instance/transaction/form.vue'),
        meta: {
            pagePermission: 'transaction.store'
        }
    },
    {
        path: 'transaction/:id/process',
        name: 'instanceTransactionProcess',
        component: () => import('../views/instance/transaction/process.vue'),
        meta: {
            pagePermission: 'transaction.store'
        }
    },
    /* -------------------------------- QRIS ------------------------------- */
    {
        path: 'qris-history',
        name: 'instanceQrisHistory',
        component: () => import('../views/instance/qris-history/index.vue'),
        meta: {
            // pagePermission: 'transaction.index'
            pagePermission: 'qris-history.index'
        }
    },
    /* -------------------------------- END TRANSACTION ------------------------------- */

    {
        path: 'report/transaction',
        name: 'instanceReportTransaction',
        component: () => import('../views/instance/report/transaction.vue'),
        meta: {
            pagePermission: 'report.transaction'
        }
    },
    {
        path: 'report/registration',
        name: 'instanceReportRegistration',
        component: () => import('../views/instance/report/registration.vue'),
        meta: {
            pagePermission: 'report.registration'
        }
    },
    {
        path: 'report/cancellation',
        name: 'instanceReportCancellation',
        component: () => import('../views/instance/report/cancellation.vue'),
        meta: {
            pagePermission: 'report.cancel'
        }
    },
    {
        path: 'report/tbp',
        name: 'instanceReportTbp',
        component: () => import('../views/instance/report/tbp.vue'),
        meta: {
            pagePermission: 'report.tbp'
        }
    },
    {
        path: 'report/determination',
        name: 'instanceReportDetermination',
        component: () => import('../views/instance/report/determination.vue'),
        meta: {
            pagePermission: 'report.determination'
        }
    },
    {
        path: 'report/sts',
        name: 'instanceReportSts',
        component: () => import('../views/instance/report/sts.vue'),
        meta: {
            pagePermission: 'report.sts'
        }
    },

    /* -------------------------------- TRANSACTION ------------------------------- */
    {
        path: 'transaction-fixed',
        name: 'instanceTransactionFixed',
        component: () => import('../views/instance/transaction-fixed/index.vue'),
        meta: {
            pagePermission: 'billing.index'
        }
    },
    {
        path: 'transaction-fixed/create',
        name: 'instanceTransactionFixedCreate',
        component: () => import('../views/instance/transaction-fixed/form.vue'),
        meta: {
            pagePermission: 'billing.store'
        }
    },
    {
        path: 'transaction-fixed/:id/edit',
        name: 'instanceTransactionFixedEdit',
        component: () => import('../views/instance/transaction-fixed/form.vue'),
        meta: {
            pagePermission: 'billing.update'
        }
    },
    /* -------------------------------- END TRANSACTION ------------------------------- */
    
    /* -------------------------------- CUSTOMER ------------------------------- */
    {
        path: 'required-retribution',
        name: 'instanceCustomer',
        component: () => import('../views/instance/customer/index.vue'),
        meta: {
            pagePermission: 'customer.index'
        }
    },
    {
        path: 'required-retribution/create',
        name: 'instanceCustomerCreate',
        component: () => import('../views/instance/customer/form.vue'),
        meta: {
            pagePermission: 'customer.store'
        }
    },
    {
        path: 'required-retribution/:id/edit',
        name: 'instanceCustomerEdit',
        component: () => import('../views/instance/customer/form.vue'),
        meta: {
            pagePermission: 'customer.update'
        }
    },
    /* -------------------------------- END CUSTOMER ------------------------------- */

    /* -------------------------------- MASTER DATA ------------------------------- */
    {
        path: 'master-data',
        name: 'instanceMasterData',
        component: () => import('../views/instance/masterData/index.vue'),
        meta: {
            pagePermission: 'master-data.index'
        }
    },
    {
        path: 'master-data/create',
        name: 'instanceMasterDataCreate',
        component: () => import('../views/instance/masterData/form.vue'),
        meta: {
            pagePermission: 'master-data.store'
        }
    },
    {
        path: 'master-data/:id/edit',
        name: 'instanceMasterDataEdit',
        component: () => import('../views/instance/masterData/form.vue'),
        meta: {
            pagePermission: 'master-data.update'
        }
    },
    /* -------------------------------- END MASTER DATA ------------------------------- */

    /* -------------------------------- USER PENGGUNA ------------------------------- */
    {
        path: 'user',
        name: 'instanceUser',
        component: () => import('../views/instance/user/index.vue'),
        meta: {
            pagePermission: 'company-user.index'
        }
    },
    {
        path: 'user/create',
        name: 'instanceUserCreate',
        component: () => import('../views/instance/user/form.vue'),
        meta: {
            pagePermission: 'company-user.store'
        }
    },
    {
        path: 'user/:id/edit',
        name: 'instanceUserEdit',
        component: () => import('../views/instance/user/form.vue'),
        meta: {
            pagePermission: 'company-user.update'
        }
    },
    /* -------------------------------- END USER PENGGUNA ------------------------------- */

    /* -------------------------------- USER PENGGUNA ------------------------------- */
    {
        path: 'unit',
        name: 'instanceUnit',
        component: () => import('../views/instance/unit/index.vue'),
        meta: {
            pagePermission: 'company-unit.index'
        }
    },
    {
        path: 'unit/create',
        name: 'instanceUnitCreate',
        component: () => import('../views/instance/unit/form.vue'),
        meta: {
            pagePermission: 'company-unit.store'
        }
    },
    {
        path: 'unit/:id/edit',
        name: 'instanceUnitEdit',
        component: () => import('../views/instance/unit/form.vue'),
        meta: {
            pagePermission: 'company-unit.update'
        }
    },
    /* -------------------------------- END USER PENGGUNA ------------------------------- */

    /* -------------------------------- SETTINGS ------------------------------- */
    {
        path: 'settings',
        name: 'instanceSettings',
        component: () => import('../views/instance/settings/index.vue'),
        meta: {
            pagePermission: 'company.setting'
        }
    },
    /* -------------------------------- END SETTINGS ------------------------------- */
]

export default routerInstance